module.exports = __webpack_public_path__ + "static/03-4c7ed6e70a17e18c27ac66cf61af59e5.jpg";